import type { UserProfile as User } from '@treu/shared'

// Auth state machine type
export type AuthState =
  | { status: 'loading' }
  | { status: 'authenticated'; user: User }
  | { status: 'unauthenticated' }

// Global auth state to prevent multiple API calls
let globalAuthState: AuthState = { status: 'loading' }
const authStateListeners = new Set<(state: AuthState) => void>()

export const getGlobalAuthState = (): AuthState => globalAuthState

export const updateGlobalAuthState = (newState: AuthState): void => {
  globalAuthState = newState
  authStateListeners.forEach(listener => listener(newState))
}

export const subscribeToAuthState = (listener: (state: AuthState) => void): (() => void) => {
  authStateListeners.add(listener)
  return () => authStateListeners.delete(listener)
}
